import { getApi } from './api';
import { IBillingMetric } from '../../model/api/customers/billing-metric';
import { ICustomerExternalBillingSettings } from '../../model/api/customers/customer-quickbook-settings';
import { AxiosResponse } from 'axios';
import { BillingMode } from '../../model/api/customers/billing-mode';
import {ICreateCustomerInvoice, ICustomerInvoice} from "../../model/api/customers/customer-quikcbook-invoices";

const URL = '/billing';

const getBillingMetrics = async (billingMode: BillingMode): Promise<Array<IBillingMetric>> => {
  const url = `${URL}/${billingMode}/metrics`;
  const api = await getApi();
  return api.get<Array<IBillingMetric>>(url).then((response: AxiosResponse<Array<IBillingMetric>>) => {
    return response.data;
  });
};

const updateCustomerBillingSettings = async (
  customerId: number,
  billingMode: BillingMode,
  qbSettings: ICustomerExternalBillingSettings,
): Promise<any> => {
  const url = `${URL}/customer/${customerId}/${billingMode}/settings`;
  const api = await getApi();
  return api.post<any>(url, qbSettings).then((res) => {
    return res;
  });
};

export const getCustomerInvoiceList = async (customerId: number): Promise<Array<ICustomerInvoice>> => {
    const api = await getApi();
    return api.get<Array<ICustomerInvoice>>(`${URL}/customer/${customerId}/invoices`).then((response: AxiosResponse<Array<ICustomerInvoice>>) => response.data);
};

export const createInvoice = async (customerId: number, createInvoice: ICreateCustomerInvoice, billingMode: BillingMode): Promise<ICustomerInvoice> => {
    const api = await getApi();
    return api.post<ICustomerInvoice>(`${URL}/customer/${customerId}/${billingMode}/invoices`, createInvoice).then((response: AxiosResponse<ICustomerInvoice>) => response.data);
};

export const createAttachment = async (customerId: number, dueDate: string, billingMode: BillingMode): Promise<ICustomerInvoice> => {
    const api = await getApi();
    return api.post<ICustomerInvoice>(`${URL}/customer/${customerId}/${billingMode}/attachment/generate`, dueDate).then((response: AxiosResponse<ICustomerInvoice>) => response.data);
};

export const getInvoiceDocument = async (customerId: number, invoiceId: number): Promise<any> => {
    const api = await getApi();
    return api.get<any>(`${URL}/customer/${customerId}/invoices/${invoiceId}/document`, {
        responseType: 'blob'
    }).then((response: AxiosResponse<any>) => response.data);
};

export const getInvoiceAttachment = async (customerId: number, invoiceId: number): Promise<any> => {
    const api = await getApi();
    return api.get<any>(`${URL}/customer/${customerId}/invoices/${invoiceId}/attachment`, {
        responseType: 'blob'
    }).then((response: AxiosResponse<any>) => response.data);
};


export const billingService = {
    getBillingMetrics,
    updateCustomerBillingSettings,
    getCustomerInvoiceList,
    createInvoice,
    createAttachment,
    getInvoiceDocument,
    getInvoiceAttachment,
};
